import './base/';
import './utilities/is-touch';
import './utilities/responsive-images';
import './recommendation-products/recommendation-products';
import './cart/cart';
import './cart/cart-utils';
import './sliders/product-slider';
import './sliders/sliders';
import './collection/toggle-filter';
import './product/ajax-actions';
import './product/quantity';
import './product/color-swatches';
import './product/variants-handler';
import './polyfills/object-fit';
import './header/header-fixed';
import './nav/mobile-nav';
import './tabs/tabs';
import './scroll-to/scroll-to';
import './select-menu/select-menu';
import './widget/widget';
import './sidebar/sidebar';
import './accordion/accordion';
import './videos/video-popups';
import './videos-background/videos-background';
import './move-up/move-up';
import './articles/index';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed
